import BodyCardGlobal from "./bodyCardGlobal/bodyCardGlobal";
import HeaderCardGlobal from "./headerCardGlobal/headerCardGlobal";
import FooterCardGlobal from "./footerCardGlobal/footerCardGlobal";
import { getSponsorClass } from '../../../functions/functions';
import './cardGlobal.sass';

/**
 * Componente de tarjeta global para deportes como fútbol, NBA, NFL, etc.
 * Representa una card enlazada con detalles del evento, incluyendo encabezado, cuerpo y pie.
 */
export default function CardGlobal({ data, flagMomios, patrocinador, indexJson }) {
  // Se define si el juego tiene una clase válida para mostrar momios
  const isValidClass = !['clarosports-finished-game', 'clarosports-error-game'].includes(data.class);
  const mostrarMomios = (flagMomios === true || flagMomios === 'true') && isValidClass;

  return (
    <a className={`carrousel-card-sponsored card-global ${getSponsorClass(patrocinador)}`} href={data.opta_event_url} target="_parent" rel="noreferrer">
      {/* Encabezado del card (fecha, torneo, lugar, etc.) */}
      <HeaderCardGlobal data={data} indexJson={indexJson}/>

      {/* Cuerpo principal del partido (jugadores, marcador, sets, etc.) */}
      <BodyCardGlobal data={data} flagMomios={flagMomios} patrocinador={patrocinador} />

      {/* Pie de tarjeta solo si aplica mostrar momios */}
      {mostrarMomios
        ? <FooterCardGlobal data={data} patrocinador={patrocinador} />
        : <div className="card-global__footer_empty"></div>
      }
    </a>
  )
}